import http from 'hub-http/clients/apiClient';
export function bulkArchive(ids) {
  return http.put('cosemail/v1/emails/archive', {
    query: {
      id: ids,
      failIfNotAllSucceed: true
    },
    data: {
      isArchived: true
    }
  });
}
export function bulkArchiveAndUnpublish(ids) {
  return http.put('cosemail/v1/emails/archive-and-unpublish', {
    query: {
      id: ids,
      failIfNotAllSucceed: true
    }
  });
}